import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { supabase } from "@/integrations/supabase/client";

const REMEMBER_KEY = "rietkuil_remember_me";
const SESSION_FLAG = "rietkuil_session_active";

function App() {
  useEffect(() => {
    // If the owner unchecked "Remember me", end the session when the tab is closed.
    const remember = localStorage.getItem(REMEMBER_KEY);
    if (remember === "false") {
      if (!sessionStorage.getItem(SESSION_FLAG)) {
        // Fresh tab/browser load after closing — sign out any lingering session.
        supabase.auth.signOut();
      }
      sessionStorage.setItem(SESSION_FLAG, "1");
    }
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <BrowserRouter basename={__BASE_PATH__}>
        <AppRoutes />
      </BrowserRouter>
    </I18nextProvider>
  );
}

export default App;
